import { Component, computed, inject, input, model, output } from '@angular/core';
import { Sector } from "../../../../domain/sector/sector"
import { SectorUiService } from '../../services/sector-ui.service';
import { IconComponent } from '../../../../shared/components/ui/icon/icon.component';
import { ButtonComponent} from '../../../../shared/components/ui/button/button'
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular/standalone';
import { SectorStateReason } from 'libs/domain';
import { SectorManualActions } from '../sector-manual-actions/sector-manual-actions.component';
import { SectorStateReasonBadge } from '../sector-state-reason-badge/sector-state-reason-badge';


@Component({
  selector: 'sector-list-card',
  imports: [IconComponent, ButtonComponent, SectorStateReasonBadge],
  templateUrl: './sector-list-card.html',
})
export class SectorListCard {
  sectorUiService = inject(SectorUiService)
  private router = inject(Router);
  route = inject(ActivatedRoute)
  
  SectorStateReason = SectorStateReason;

  iconPlay = "play";

  sector = model.required<Sector>();
  editMode = input(false);
  descriptionChange = output<string>();

  iconStateName = computed(() => {
    return this.sectorUiService.getSectorIconStateName(this.sector()?.state, this.sector()?.mode);
  });

  sectorModeString = computed(() => {
    return this.sectorUiService.getSectorModeString(this.sector()?.mode);
  });

  showFlowInfo = computed( () => {
    return this.sectorUiService.checkSectorTypeIrrigationOutlet(this.sector()?.type);
  });

  schedulingPersonIcon = computed(() => {
    return this.sectorUiService.getSectorUserIconName(this.sector()?.schedulingPersonType);
  });

  constructor(private modalCtrl: ModalController) {}

  async openManualActionsModal() {
    const modal = await this.modalCtrl.create({
      component: SectorManualActions,
      componentProps: {sector: this.sector},
      backdropDismiss: true,

    })
    
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (data) {
      this.sector.set(data);
    }
  }
}
